module.exports = __webpack_public_path__ + "img/3.ada85338.png";